<template>
  <div id="layout-storybook">
    <template v-if="!$store.state.isFullLoading">
      <Header @toggle-nav="toggleNav" />
      <StorybookMenu :isOpenedNav="isOpenedNav" >
        <router-view/>
      </StorybookMenu>
      <component :is="'style'">
        :root {
          --fontFamilyBase: 'db_heavent_rounded'
        }
      </component>
    </template>
    <FadeTransition>
      <FullLoading v-if="$store.state.isFullLoading"/>
    </FadeTransition>
  </div>
</template>

<script>
import Layout from '@/layouts/layout.vue'
export default {
  data () {
    return {
      isOpenedNav: false
    }
  },
  extends: Layout,
  components: {
    Header: () => import('../components/Header.vue'),
    StorybookMenu: () => import('../components/StorybookMenu.vue'),
    FullLoading: () => import('../components/FullLoading.vue'),
    FadeTransition: () => import('../components/FadeTransition.vue')
  },
  mounted () {
    this.$store.commit('SET_STATE', { name: 'isFullLoading', val: true })
    this.$nextTick(async () => {
      this.checkAuthentication()
      this.$store.commit('SET_STATE', { name: 'domain', val: window.location.hostname })
      this.onResize()
      const lang = this.$store.state.locale
      this.setLanguage(lang, this.$i18n)
      setTimeout(() => {
        this.$store.commit('SET_STATE', { name: 'isFullLoading', val: false })
      }, 1000)
    })
  },
  watch: {
    '$store.state.locale' (val, oldVal) {
      this.setLanguage(val)
    }
  },
  methods: {
    async checkAuthentication () {
      const isAuthenticated = await this.$store.dispatch('checkAuthen')
      if (!isAuthenticated) {
        this.$router.replace('/account/login')
      }
    },
    onResize () {
      this.$store.commit('SET_STATE', { name: 'windowWidth', val: window.innerWidth })
      this.$store.commit('SET_STATE', { name: 'windowHeight', val: window.innerHeight })
    },
    async setLanguage (lang, i18nContext) {
      const res = await this.$store.dispatch('setLanguage', { lang, i18nContext, context: this })
      window.localStorage.setItem('language', res)
      if (this.$i18n) this.$i18n.locale = res
    },
    toggleNav () {
      this.isOpenedNav = !this.isOpenedNav // toggle the Nav state
    }
  }
}
</script>

<style lang="scss">

#layout-storybook {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

@import '../../lib/design-token/config-layout.scss';
@import '../../public/css/font-stylesheet.css';

</style>
